import React, { Component } from 'react';

export default class Mapping extends Component {

    render () {
        return <h1>This is the Mapping page.</h1>
    }

}
